<div class="main-container">
  <app-wallet-select-currency [isShowBackIcon]="false"></app-wallet-select-currency>
</div>
